module.exports = __webpack_public_path__ + "static/img/yeswecan0018.23634e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/yeswecan0018.png
// module id = 593
// module chunks = 1